import { render, staticRenderFns } from "./TableRowActivePatientsSubtotal.vue?vue&type=template&id=659a6156&lang=pug&"
import script from "./TableRowActivePatientsSubtotal.vue?vue&type=script&lang=js&"
export * from "./TableRowActivePatientsSubtotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('659a6156')) {
      api.createRecord('659a6156', component.options)
    } else {
      api.reload('659a6156', component.options)
    }
    module.hot.accept("./TableRowActivePatientsSubtotal.vue?vue&type=template&id=659a6156&lang=pug&", function () {
      api.rerender('659a6156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowActivePatientsSubtotal.vue"
export default component.exports